import {useTranslation} from '@aboutyou/i18n';
import {useOpenedStateManager} from '@aboutyou/opened-state-manager';
import React from 'react';
import styled from 'styled-components';
import {FONT_WEIGHTS} from '../../../../constants/typography';
import {GenericIconName} from '../../../atoms/Icon/IconName';
import {BadgeWithBorderRadius} from '../../BadgeList/badges/GenericBadges';

export const useSizeRecommendationInfo = () => {
  return useOpenedStateManager('YOU_SIZE_BADGE_INFO');
};

export const YourSizeBadge: React.FC<{
  ['data-testid']?: string;
  showInfoIcon?: boolean;
}> = ({'data-testid': dataTestId, showInfoIcon}) => {
  const {t} = useTranslation();
  const {open} = useSizeRecommendationInfo();

  const onInfoIconClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    open();
  };

  return (
    <StyledBadgeWithBorderRadius
      dataTestId={dataTestId}
      onClick={showInfoIcon ? onInfoIconClick : undefined}
      text={t('Your size')}
      svgIcon={
        showInfoIcon
          ? {
              iconName: GenericIconName.Info,
              iconSize: 'XSS',
              showToTheRight: true,
            }
          : undefined
      }
    />
  );
};

const StyledBadgeWithBorderRadius = styled(BadgeWithBorderRadius)`
  background-color: rgba(229, 229, 229, 0.5);
  margin: 0;
  height: 22px;
  line-height: 1;
  &&& {
    font-weight: ${FONT_WEIGHTS.light};
  }
`;
